import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentMethod'
})
export class PaymentMethodPipe implements PipeTransform {

  method: string = '';

  transform(value: number): unknown {
    if (value === 0) {
      this.method = 'Efectivo'
    } else {
      this.method = 'Tarjeta'
    }
    return this.method;
  }

}
